export default __webpack_public_path__ + "static/media/dhl-icon.df243f29.svg";